"use client";
import { useStore } from "@nanostores/react";
import clsx from "clsx";
import type { CustomerData } from "../../getCustomerData";
import { HeaderInner } from "./HeaderInner";
import { mobileMenuOpenStateStore } from "./mobileMenu";

type Props = {
  customerData: CustomerData;
};
export const Header = ({ customerData }: Props) => {
  const isMenuOpen = useStore(mobileMenuOpenStateStore);

  return (
    <div className="h-[60px] xl:h-20 w-full fixed top-0 z-21">
      <div
        className={clsx("bg-linear-to-b from-bg-1/70 absolute inset-0", {
          hidden: isMenuOpen,
        })}
      />
      <div
        className={clsx("[mask:linear-gradient(black,black,transparent)] absolute inset-0 backdrop-blur-lg", {
          hidden: isMenuOpen,
        })}
      />
      <HeaderInner customerData={customerData} />
    </div>
  );
};
